<ng-container *ngIf="initialized">
  <img loading="lazy" width="1px" height="1px" src="https://hangfire.behaviorlive.com/track-job?trackingActionType={{action}}&jobId={{jobId}}&clientIdentifier={{clientId}}&userId={{userId}}">
</ng-container>
